import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import React, { useEffect, useState } from 'react';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, formatCurrency, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../../../commons/functions';
import { useGlobalState } from '../../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../../layout';
const _preserve = React.version;
//import { useStoreAdmin } from '../../../../context/useStoreAdmin';
import Favorites from '../../../../../../components/extras/Favorites';
import SidePanelMovement from '../../../../../../components/extras/SidePanelMovement';
import TableMovements from '../../../../../../components/tables/tableMovements';
import { fetchWithWatch } from '../../../../../../hooks/fetchWithWatch';
import { ItemsMovement } from '../../../../../../resources/types';

const pageSize = 20;

export const MembersAccountsClubPage = () => {
  //const storeAdmin = useStoreAdmin();

  const { menu, parameters, data } = useGlobalState();


  const { idUser } = useGlobalState();
  const [movements, setMovements] = useState<ItemsMovement[]>([]);
  const [movement, setMovement] = useState<Partial<ItemsMovement>>({});

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.split("?")[1]);
      const id = params.get("id");

      if (id) {
        handleGetMovement(parseInt(id))
      } else {
        setMovement(undefined)
        handleRefreshMovements();
      }
    };
    window.addEventListener("hashchange", handleHashChange);
    handleHashChange();
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  useEffect(() => {
    handleRefreshMovements();
  }, [parameters]); //parameters.startDate, parameters.endDate, 


  const handleGetMovement = async (idMovement: number) => {
    //if (parameters.startDate && parameters.endDate) { 
    if (parameters.year && parameters.month && data) {

      try {
        setLoading(true)
        const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-routing': '/private/user/movements/movement',
            'JWT': getCookie("JWT"),
            //  
          },
          body: JSON.stringify(
            {
              idMovement: idMovement
            }
          ),
          //mode: 'no-cors'  // Bypasses CORS but limits the response
        });

        if (!response.ok) {
          throw new Error(`HTTP error: ${response.status}`);
        }
        const dataWeb = await response.json();
        addNotificationStatus(dataWeb, setData);
        if (dataWeb.code == 0) {
          if (dataWeb.movement)
            setMovement(dataWeb.movement);
        }
      } catch (error: any) {
        addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
      } finally { setLoading(false) }

    };
  }

  const handleRefreshMovements = async () => {
    //if (parameters.startDate && parameters.endDate) { 
    if (parameters.year && parameters.month && data) {

      try {
        setLoading(true)
        const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-routing': '/private/user/movements/list',
            'JWT': getCookie("JWT"),
            //  
          },
          body: JSON.stringify(
            {
              //dateStart: parameters.startDate,
              //dateEnd: parameters.endDate,
              year: parameters.year,
              month: parameters.month,
              orderBy: "dateTransaction",
              order: "desc",
              orderBy2: "idMovement",
              order2: "desc",
              columns: "idMovement,idUser,RUT,accountPlan,ammount,balance,data,dateTransaction,displayName,idAccountPlan,idCharge,receipt,jsonBank,jsonDocuments,jsonMovement,jsonTBK"
            }
          ),
          //mode: 'no-cors'  // Bypasses CORS but limits the response
        });

        if (!response.ok) {
          throw new Error(`HTTP error: ${response.status}`);
        }
        const dataWeb = await response.json();
        addNotificationStatus(dataWeb, setData);
        if (dataWeb.code == 0) {
          setMovements(dataWeb.movements);
        }
      } catch (error: any) {
        addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
      } finally { setLoading(false) }

    };
  }
  return (
    <CustomAppLayout
      toolsHide
      splitPanelOpen={!!movement}
      onSplitPanelToggle={({ detail }) => !detail.open ? window.location.hash = `members/accounts/statements/club` : null}
      splitPanel={
        <SidePanelMovement movement={movement ?? {}} />
      }

      contentType="form"
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <>
          <SpaceBetween direction="vertical" size="xs">

            <Header actions={
              <SpaceBetween direction="horizontal" size="xs">

                <Favorites />
              </SpaceBetween>
            }
              info={formatCurrency(data?.balance, "CLP")}
            >
              Cartola cuenta club</Header>

            <TableMovements showUser={false} dateFilter='PERIOD' filter={false} excel onSelect={(row) => {
              window.location.hash = `members/accounts/statements/club?id=${row.idMovement}`;
            }} movements={movements} visible={true} refresh={false}
              //showBalance={true}
              showBalances
              onRangeChange={(startDate, endDate) => {

                const updatedParameters = { ...parameters, startDate: startDate, endDate: endDate, };
                setParameters(updatedParameters);

              }}
            />

          </SpaceBetween>
        </>
      }
    />
  );
};
